var map = {
	"./abathur.json": 98076,
	"./alarak.json": 1797,
	"./alexstrasza.json": 779,
	"./ana.json": 1863,
	"./anduin.json": 53324,
	"./anubarak.json": 79084,
	"./artanis.json": 65119,
	"./arthas.json": 1852,
	"./auriel.json": 88433,
	"./azmodan.json": 41107,
	"./blaze.json": 10709,
	"./brightwing.json": 40884,
	"./cassia.json": 1887,
	"./chen.json": 84663,
	"./cho.json": 65213,
	"./chromie.json": 92024,
	"./deathwing.json": 11316,
	"./deckard.json": 36511,
	"./dehaka.json": 45596,
	"./diablo.json": 22122,
	"./dva.json": 75172,
	"./etc.json": 12687,
	"./falstad.json": 5172,
	"./fenix.json": 84553,
	"./gall.json": 70635,
	"./garrosh.json": 92439,
	"./gazlowe.json": 87166,
	"./genji.json": 93602,
	"./greymane.json": 74491,
	"./guldan.json": 40580,
	"./hanzo.json": 96229,
	"./hogger.json": 16011,
	"./illidan.json": 7700,
	"./imperius.json": 36303,
	"./jaina.json": 83340,
	"./johanna.json": 13626,
	"./junkrat.json": 81268,
	"./kaelthas.json": 89258,
	"./kelthuzad.json": 48391,
	"./kerrigan.json": 85896,
	"./kharazim.json": 7030,
	"./leoric.json": 31613,
	"./li-ming.json": 7342,
	"./lili.json": 2759,
	"./lt-morales.json": 17925,
	"./lucio.json": 61597,
	"./lunara.json": 52220,
	"./maiev.json": 81247,
	"./malfurion.json": 81310,
	"./malganis.json": 33447,
	"./malthael.json": 44947,
	"./medivh.json": 4324,
	"./mei.json": 36320,
	"./mephisto.json": 66880,
	"./muradin.json": 23187,
	"./murky.json": 95601,
	"./nazeebo.json": 70569,
	"./nova.json": 40257,
	"./orphea.json": 84264,
	"./probius.json": 54607,
	"./qhira.json": 81260,
	"./ragnaros.json": 22234,
	"./raynor.json": 1500,
	"./rehgar.json": 54280,
	"./rexxar.json": 71233,
	"./samuro.json": 84478,
	"./sgt-hammer.json": 97336,
	"./sonya.json": 24287,
	"./stitches.json": 24810,
	"./stukov.json": 66113,
	"./sylvanas.json": 15414,
	"./tassadar.json": 65748,
	"./the-butcher.json": 93676,
	"./the-lost-vikings.json": 43105,
	"./thrall.json": 19242,
	"./tracer.json": 45446,
	"./tychus.json": 20611,
	"./tyrael.json": 72628,
	"./tyrande.json": 99650,
	"./uther.json": 14281,
	"./valeera.json": 79693,
	"./valla.json": 4161,
	"./varian.json": 58036,
	"./whitemane.json": 81963,
	"./xul.json": 54716,
	"./yrel.json": 37893,
	"./zagara.json": 31091,
	"./zarya.json": 34386,
	"./zeratul.json": 9184,
	"./zuljin.json": 98299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70449;